import React from 'react';
import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { formatDate } from 'utils';

function PermissionsTable({
  items,
  modules,
  current,
  pageSize,
  loading,
  totalRows,
  onRowClick,
  onChange,
}) {
  const columns = [
    {
      title: 'Наименование',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
    },
    {
      title: 'Модуль',
      dataIndex: 'module_id',
      key: 'module_id',
      render: (moduleId) => {
        if (modules && modules.length) {
          return modules.find((item) => item.id === moduleId).name;
        }
        return moduleId;
      },
    },
    {
      title: 'Функция',
      dataIndex: 'function',
      key: 'function',
    },
    {
      title: 'Дата создания',
      dataIndex: 'created',
      key: 'created',
      render: (date) => formatDate(date),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      tableLayout="fixed"
      scroll={{ y: SCROLL_Y }}
      pagination={{
        current,
        total: totalRows,
        pageSize,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { PermissionsTable };
